import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import SignDocementModel from 'src/components/document-management/signature-document-popup';
import Loader from 'src/components/LoaderImg/loader.gif';
import { resetNewDocumentSignAction } from 'src/redux/actions/documentationAction';
import { getAccessToken } from 'src/routes/AuthContext';

function DashboardDocSignaturePreviewNew() {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isDocSigned, setIsDocSigned] = useState({
    isSuccessful: false,
    pdfUrl: '',
  });
  const [openNewSignModel, setOpenNewSignModel] = useState(false);

  const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);

  const getDashboardSignDoc = useSelector(
    (state: any) => state.getSignatureTemplateReducer.getDashboardDoc
  );

  const getDashboardSignDocLoading = useSelector(
    (state: any) => state.getSignatureTemplateReducer.loader
  );

  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  const handleOpenNewSignModel = () => {
    if (isDocSigned.isSuccessful) {
      navigate('/dashboard');
    } else {
      dispatch(resetNewDocumentSignAction());
      setOpenNewSignModel(true);
    }
  };

  const handleCloseNewSignModel = () => {
    setOpenNewSignModel(false);
    dispatch(resetNewDocumentSignAction());
  };

  return (
    <>
      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
        >
          <Link
            style={{ color: '#111927' }}
            to={`${state?.source === 'PHYSICIAN' ? '/physician-dashboard' : '/dashboard'}`}
          >
            <Typography variant="subtitle1">Back to Dashboard</Typography>
          </Link>
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          alignItems="center"
          justifyContent={'space-between'}
        >
          <Typography variant="h5">
            Preview document - {getDashboardSignDoc?.documentType}
          </Typography>
          <Button
            variant="contained"
            onClick={handleOpenNewSignModel}
          >
            {isDocSigned.isSuccessful ? 'Submit' : 'Start signing'}
          </Button>
        </Stack>
      </Stack>
      {getDashboardSignDocLoading ? (
        <img
          src={Loader}
          alt="loader"
          style={{ width: '10%', margin: 'auto' }}
        />
      ) : (
        <Box
          sx={{ height: '100%' }}
          p={3}
        >
          <iframe
            src={
              isDocSigned.isSuccessful
                ? isDocSigned.pdfUrl
                : getDashboardSignDoc?.pdfUrl
                ? getDashboardSignDoc?.pdfUrl
                : ''
            }
              title='dashboard-sign'
            ref={updateIFrameRef}
            width={'100%'}
            height={'100%'}
            style={{ border: 'none' }}
          />
        </Box>
      )}

      <BootstrapDialog
        PaperProps={{ style: { width: '600px' } }}
        onClose={handleCloseNewSignModel}
        aria-labelledby="customized-dialog-title"
        open={openNewSignModel}
      >
        <SignDocementModel
          onClose={handleCloseNewSignModel}
          setIsDocSigned={setIsDocSigned}
          formSubmissionUuid={getDashboardSignDoc.uuid}
          isSupervisor={user?.providerId === getDashboardSignDoc.supervisorId}
          docType={getDashboardSignDoc?.formType}
          open
        />
      </BootstrapDialog>
    </>
  );
}

export default DashboardDocSignaturePreviewNew;
